// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__17ljZ","title":"Images45_title__2RCB2","images":"Images45_images__33Wke"};